import { CircleSpinner, CircleSpinnerInline } from '@newfront-insurance/core-ui';
import React, { Suspense } from 'react';

function Spinner(_ref) {
  let {
    loadingText,
    variant
  } = _ref;

  switch (variant) {
    case 'inline':
      return /*#__PURE__*/React.createElement(CircleSpinnerInline, {
        label: loadingText
      });

    default:
      return /*#__PURE__*/React.createElement(CircleSpinner, {
        label: loadingText
      });
  }
}
function FallbackSuspense(_ref2) {
  let {
    children,
    loadingText = 'Loading...',
    variant = 'default'
  } = _ref2;
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Spinner, {
      variant: variant,
      loadingText: loadingText
    })
  }, children);
}

export { FallbackSuspense as F };
